import styled, { css } from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const SubscriptionHeader = styled.div`
  ${({ theme }) => css`
    height: 80px;
    background: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    margin: 20px 20px 10px 20px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-family: ${theme.v2.font.family.primary};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: auto;
      min-height: 80px;
      flex-wrap: wrap;
      align-items: center;
      padding: 16px 20px;
    }
  `}
`;

export const SubscriptionPlanName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowPure};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const SubscriptionSeparator = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowPure};
    margin: 0 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const SubscriptionDomainName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowLight};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 218px);
    width: calc(100% - 40px);
    overflow: hidden;
    background: linear-gradient(180deg, ${theme.v2.colors.brand.primaryLowLight} 0%, ${theme.v2.colors.white.primary} 100%);
    margin: 0px 20px 20px 20px;
    border-radius: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-height: calc(100vh - 319px);
    }
  `}
`;

export const BackgroundGlow1 = styled.div`
  ${({ theme }) => css`
    position: absolute;
    bottom: -200px;
    right: -200px;
    width: 496px;
    height: 496px;
    background: ${theme.v2.colors.brand.primaryLight};
    border-radius: 50%;
    filter: blur(120px);
    opacity: 0.6;
    pointer-events: none;
    z-index: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 140px;
      height: 140px;
      bottom: -40px;
      right: -40px;
      filter: blur(60px);
    }
  `}
`;

export const BackgroundGlow2 = styled.div`
  ${({ theme }) => css`
    position: absolute;
    bottom: -200px;
    left: -200px;
    width: 496px;
    height: 496px;
    background: ${theme.v2.colors.brand.primaryLight};
    border-radius: 50%;
    filter: blur(120px);
    opacity: 0.6;
    pointer-events: none;
    z-index: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 140px;
      height: 140px;
      bottom: -40px;
      left: -40px;
      filter: blur(60px);
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    min-width: 636px;
    width: 100%;
    padding: 24px;
    z-index: 1;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: unset;
      max-width: 100%;
      margin: 0;
      gap: 32px;
      padding: 20px;
    }
  `}
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const IllustrationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 142px;
  height: 89px;
`;

export const Illustration = styled.img`
  width: 142px;
  height: 89px;
  object-fit: contain;
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.blackPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: 28px;
    line-height: 36.4px;
    text-align: center;
    margin: 0;
    width: 100%;
    white-space: normal;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: 24px;
      line-height: 31.2px;
    }
  `}
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 100%;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 27px;
    text-align: center;
    margin: 0;
    width: 100%;
    white-space: normal;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      line-height: 24px;
    }
  `}
`;

export const ContentButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 21px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      line-height: 19.5px;
    }
  `}
`;
